import { useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { logout } from "../../lib/auth";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: "📊", end: true },
  { to: "/admin/reservations", label: "Rezervace", icon: "📋" },
  { to: "/admin/calendar", label: "Kalendář", icon: "🗓️" },
  { to: "/admin/invoices", label: "Faktury", icon: "🧾" },
  { to: "/admin/kindergartens", label: "Školky", icon: "🏫" },
  { to: "/admin/programs", label: "Programy", icon: "✨" },
  { to: "/admin/site-images", label: "Fotky webu", icon: "📷" },
  { to: "/admin/settings", label: "Nastavení", icon: "⚙️" },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  async function handleLogout() {
    await logout();
    nav("/admin/login", { replace: true });
  }

  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Sidebar — desktop */}
      <aside className="hidden w-64 shrink-0 border-r border-slate-200 bg-white md:block">
        <SidebarContent onItemClick={() => setMobileOpen(false)} onLogout={handleLogout} />
      </aside>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden" onClick={() => setMobileOpen(false)}>
          <div className="absolute inset-0 bg-black/50" />
          <aside className="absolute left-0 top-0 h-full w-64 bg-white shadow-xl" onClick={(e) => e.stopPropagation()}>
            <SidebarContent onItemClick={() => setMobileOpen(false)} onLogout={handleLogout} />
          </aside>
        </div>
      )}

      {/* Main */}
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-3 md:hidden">
          <button
            onClick={() => setMobileOpen(true)}
            className="rounded-lg p-2 text-slate-600 hover:bg-slate-100"
            aria-label="Otevřít menu"
          >
            ☰
          </button>
          <Link to="/admin" className="font-semibold text-obloha-indigo-900">
            🌌 Kouzelná Obloha
          </Link>
          <div className="w-8" />
        </header>

        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function SidebarContent({ onItemClick, onLogout }: { onItemClick: () => void; onLogout: () => void }) {
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-slate-200 p-5">
        <div className="text-lg font-bold text-obloha-indigo-950">🌌 Kouzelná Obloha</div>
        <div className="text-xs text-slate-500">Administrace</div>
      </div>

      <nav className="flex-1 space-y-1 p-3">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={onItemClick}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition ${
                isActive
                  ? "bg-obloha-indigo-50 text-obloha-indigo-800"
                  : "text-slate-600 hover:bg-slate-100"
              }`
            }
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-slate-200 p-3">
        <button onClick={onLogout} className="btn-secondary w-full">
          Odhlásit se
        </button>
      </div>
    </div>
  );
}
